export default __webpack_public_path__ + "static/media/aboutus.48416021.jpg";